import { Dispatch, FC, SetStateAction } from 'react'
import { produce } from 'immer'
import { Label } from '@progress/kendo-react-labels'
import { StackLayout } from '@progress/kendo-react-layout'
import { Input } from '@progress/kendo-react-inputs'
import {
  NormalStatusSelect,
  ExpenseSelect,
  BranchSelect
} from '../../../components/parts'
import { SearchCondition } from '@gateway.maintenance'

const changeSearchConditionDataType = (value: string[] | number[]) => {
  if (value.length > 0) {
    if (typeof value[0] === 'number') {
      return value.map((item) => {
        return item.toString()
      })
    }
    if (typeof value[0] === 'string') {
      return value.map((item) => {
        return Number(item)
      })
    }
  }

  return []
}
export interface SupplierConditionProps {
  searchCondition: SearchCondition
  setSearchCondition: Dispatch<SetStateAction<SearchCondition>>
}

export const SupplierCondition: FC<SupplierConditionProps> = ({
  setSearchCondition,
  searchCondition
}) => {
  /**
   * Conditionの変更
   */
  const handleChangeCondition = (
    value: string | string[] | number[],
    name: keyof SearchCondition
  ) => {
    setSearchCondition(
      produce((draft) => {
        if (name === 'supplierNm' || name === 'supplierPerson' || name === 'supplierBranchNm') {
          draft[name] = value as string
        }
        if (name === 'branches' || name === 'expense') {
          draft[name] = value as string[]
        }
        if (
          name === 'buildingDiscloseFlg' ||
          name === 'ourCompanyCapacityFlg' ||
          name === 'soyukaiFlg' ||
          name === 'hearingSheetFlg' ||
          name === 'replyReqFlg'
        ) {
          draft[name] = value as number[]
        }
      })
    )
  }

  return (
    <>
      <h3>検索条件</h3>

      <StackLayout gap={5} orientation="vertical">
        <Label>業者名</Label>
        <Input
          onChange={(event) => handleChangeCondition(event.value, 'supplierNm')}
          value={searchCondition.supplierNm}
        />

        <Label>業者支店名</Label>
        <Input
          onChange={(event) => handleChangeCondition(event.value, 'supplierBranchNm')}
          value={searchCondition.supplierBranchNm ?? ''}
        />

        <Label>管轄支店</Label>
        <BranchSelect
          multiple
          onChange={(value) => handleChangeCondition(value, 'branches')}
          value={searchCondition.branches}
          autoClose={false}
        />

        <Label>担当者</Label>
        <Input
          onChange={(event) =>
            handleChangeCondition(event.value, 'supplierPerson')
          }
          value={searchCondition.supplierPerson}
        />

        <Label>費目</Label>
        <ExpenseSelect
          multiple
          onChange={(value) => handleChangeCondition(value, 'expense')}
          value={searchCondition.expense}
          autoClose={false}
        />

        <Label>物件情報開示指定</Label>
        <NormalStatusSelect
          multiple
          onChange={(value) => {
            handleChangeCondition(
              changeSearchConditionDataType(value) ?? [],
              'buildingDiscloseFlg'
            )
          }}
          value={
            changeSearchConditionDataType(
              searchCondition.buildingDiscloseFlg ?? []
            ) as string[]
          }
        />

        <Label>入場可能人数指定</Label>
        <NormalStatusSelect
          multiple
          onChange={(value) => {
            handleChangeCondition(
              changeSearchConditionDataType(value) ?? [],
              'ourCompanyCapacityFlg'
            )
          }}
          value={
            changeSearchConditionDataType(
              searchCondition.ourCompanyCapacityFlg ?? []
            ) as string[]
          }
        />

        <Label>倉友会指定</Label>
        <NormalStatusSelect
          multiple
          onChange={(value) => {
            handleChangeCondition(
              changeSearchConditionDataType(value) ?? [],
              'soyukaiFlg'
            )
          }}
          value={
            changeSearchConditionDataType(
              searchCondition.soyukaiFlg ?? []
            ) as string[]
          }
        />

        <Label>ヒアリングシート指定</Label>
        <NormalStatusSelect
          multiple
          onChange={(value) => {
            handleChangeCondition(
              changeSearchConditionDataType(value) ?? [],
              'hearingSheetFlg'
            )
          }}
          value={
            changeSearchConditionDataType(
              searchCondition.hearingSheetFlg ?? []
            ) as string[]
          }
        />

        <Label>回答依頼指定</Label>
        <NormalStatusSelect
          multiple
          onChange={(value) => {
            handleChangeCondition(
              changeSearchConditionDataType(value),
              'replyReqFlg'
            )
          }}
          value={
            changeSearchConditionDataType(
              searchCondition.replyReqFlg ?? []
            ) as string[]
          }
        />
      </StackLayout>
    </>
  )
}
